"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line:no-any
exports.reduceTransforms = (transforms) => 
// tslint:disable-next-line:no-any
(value, index, array) => {
    return transforms.reduce((acc, method) => method(acc, index, array), value);
};
exports.default = exports.reduceTransforms;
//# sourceMappingURL=reduce_transforms.js.map